(ns ycweb.app.website.dlp.widgets.blockquote
  (:require
   [rum.core :as rum]
   [util.transform :as trf]))

(rum/defc block-quote < rum/reactive [{is-article? :isarticle} {:keys [properties]}]
  (let [{:block-quote/keys [content author]} properties]
    (when content
      [:div.u-block-center.u-max-width-720
       {:class [(when (trf/toboolean is-article?) "yc-article")]}
       [:blockquote.yc-blockquote.yc-simple-text
        [:p
         [:i content]
         (when author
           (str " - " author))]]])))
